export enum AccessLevel {
    Public = 'public',
    Internal = 'internal',
}
